import { shareKakaoCard, type KakaoCardShareMode, type KakaoShareOptions } from '../../kakao-share';
import { TOOL_URL } from './environment';

/**
 * "카카오톡으로 알려주기" shares the TOOL link, never the result: the report
 * stays on this device. Uses the site's fixed 800×400 Kakao share image.
 */

export const TOOL_SHARE_IMAGE_URL = 'https://oneultool.com/brand/oneultool-kakao-share-800x400.png';

export function toolShareOptions(url = TOOL_URL): KakaoShareOptions {
  const link = { mobileWebUrl: url, webUrl: url };
  return {
    objectType: 'feed',
    content: {
      title: '카톡 성적표',
      description: '우리 카톡 성적표 나왔다! 선톡·답장 속도·말버릇까지 채점해 봐요',
      imageUrl: TOOL_SHARE_IMAGE_URL,
      link,
    },
    buttons: [{ title: '내 카톡도 채점하기', link }],
  };
}

export function shareToolOnKakao(key?: string): Promise<KakaoCardShareMode> {
  return key === undefined ? shareKakaoCard(toolShareOptions()) : shareKakaoCard(toolShareOptions(), key);
}

export function kakaoShareToast(mode: KakaoCardShareMode): string {
  switch (mode) {
    case 'kakao':
      return '카카오톡 공유 화면을 열었어요.';
    case 'kakao-ready':
      return '카카오톡 공유 준비가 끝났어요. 버튼을 한 번 더 눌러 주세요.';
    case 'unavailable':
      return '카카오톡 공유를 준비하지 못했어요. 링크 복사를 이용해 주세요.';
  }
}
